import { render } from "./Mapping.vue?vue&type=template&id=8030692a"
import script from "./Mapping.vue?vue&type=script&setup=true&lang=js"
export * from "./Mapping.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Settings/Mapping.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8030692a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8030692a', __exports__)) {
    api.reload('8030692a', __exports__)
  }
  
  module.hot.accept("./Mapping.vue?vue&type=template&id=8030692a", () => {
    api.rerender('8030692a', render)
  })

}


export default __exports__